import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  Paper,
  Typography,
  Button,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  withStyles,
} from '@material-ui/core';

import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../../utils/common';
import WarningForm from './Dialog/WarningForm';

class SubOrganization extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isChanged: false,
      rowIndex: null,
      dialogWarningForm: {
        id: null,
        name: null,
        open: false,
      },
      organizations: [],
    };
  }

  async componentDidMount() {
    console.log('componentDidMount from SubOrganization');
    const { tenantId } = this.props.tenant.toJS();
    if (tenantId) {
      const tenantIds = [tenantId];
      this.initOrganizationData(tenantIds);
    }
  }

  async initOrganizationData(tenantIds) {
    let groupsList = await this.props.group.getGroupList(tenantIds);
    groupsList = (groupsList || []).map((group) => {
      return {
        id: group.id,
        locationId: group.locationId,
        tenantId: group.tenantId,
        name: group.name,
        description: group.description,
        isChange: false,
      };
    });
    this.setState({ organizations: groupsList });
  }

  handleSetNavigation = (activeStep) => {
    const { navigations } = this.props.wizard.toJS();
    const step = activeStep - 1;
    const nav = navigations.filter((nav) => nav.wizardStep < step);
    this.props.wizard.setNavigation(nav);
  };

  handleNavigation = () => {
    const { navigations, activeStep } = this.props.wizard.toJS();
    const nav = [...navigations];
    const data = {
      wizardStep: activeStep,
      wizardPage: 'unit',
      wizardName: 'wizard_step_unit',
    };
    nav.push(data);
    this.props.wizard.setNavigation(nav);
  };

  handleNext = () => {
    const { t } = this.props;
    const { isChanged, organizations } = this.state;
    const { activeStep } = this.props.wizard.toJS();
    const isValidName = organizations.find((organization) => organization.name === '');

    if (isValidName) {
      Swal.fire({
        html: `<h4>This is a required Organization Name.`,
        type: 'warning',
      });
    } else {
      if (isChanged) {
        Swal.fire({
          html: `<h4>${t('wizard_ask_save_change')}`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: `${t('cancel')}`,
          confirmButtonText: `${t('save')}`,
          reverseButtons: true,
          customClass: {
            container: 'my-swal',
          },
        }).then(async (result) => {
          if (result.value) {
            await this.handleSave();
            this.handleNavigation();
            this.props.wizard.nextStep(activeStep);
          }
        });
      } else {
        this.handleNavigation();
        this.props.wizard.nextStep(activeStep);
      }
    }
  };

  handleBack = () => {
    const { t } = this.props;
    const { activeStep } = this.props.wizard.toJS();
    const { organizations, isChanged } = this.state;
    const isChangeData = organizations.filter((organization) => organization.isChange === true);
    const isValidName = organizations.find((organization) => organization.name === '');
    if (isValidName) {
      Swal.fire({
        html: `<h4>This is a required Organization Name.`,
        type: 'warning',
      });
    } else {
      if (isChangeData.length > 0 || isChanged) {
        Swal.fire({
          html: `<h4>${t('wizard_ask_save_change')}`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: `${t('cancel')}`,
          confirmButtonText: `${t('save')}`,
          reverseButtons: true,
          customClass: {
            container: 'my-swal',
          },
        }).then(async (result) => {
          if (result.value) {
            await this.handleSave();

            this.handleSetNavigation(activeStep);
            this.props.wizard.backStep(activeStep);
          }
        });
      } else {
        this.handleSetNavigation(activeStep);
        this.props.wizard.backStep(activeStep);
      }
    }
  };

  handleSave = async () => {
    const { t } = this.props;
    const { tenantId } = this.props.tenant.toJS();
    const { organizations } = this.state;
    const isValidName = organizations.find((organization) => organization.name === '');

    if (isValidName) {
      Swal.fire({
        html: `<h4>This is a required Organization Name.`,
        type: 'warning',
      });
    } else {
      try {
        const data = {
          tenantId,
          organizations,
        };
        const result = await this.props.group.updateGroups(data);
        if (result.statusCode === 200) {
          this.setState({ isChanged: false });
          this.initOrganizationData([tenantId]);
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else if (e.statusCode === 400) {
          const msg = e.error.message || `${t('failed_to_update')}`;
          Swal.fire({ html: `<h4>${msg}`, type: 'error' });
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
        }
      }
    }
  };

  handleClickCreate = () => {
    const { tenantId } = this.props.tenant.toJS();
    const { locationId } = this.props.locations.toJS();
    const organizations = [...this.state.organizations];
    const data = {
      locationId,
      tenantId,
      name: '',
      description: '',
      isChange: false,
    };
    organizations.unshift(data);
    this.setState({ organizations, isChanged: true });
  };

  handleDelete = () => {
    const { organizations, dialogWarningForm } = this.state;
    const results = organizations.filter((data, i) => i !== dialogWarningForm.id);
    this.setState({ organizations: results, isChanged: true });
    this.handleCloseWarningForm();
  };

  handleResetData = () => {
    const { tenantId } = this.props.tenant.toJS();
    this.setState({ isChanged: false });
    this.initOrganizationData([tenantId]);
  };

  handleOpendWarningForm = (id, name) => {
    this.setState({
      dialogWarningForm: {
        id,
        name,
        open: true,
      },
    });
  };

  handleCloseWarningForm = () => {
    this.setState({
      dialogWarningForm: {
        ...this.state.dialogWarningForm,
        open: false,
        // id: null,
        // name: null,
      },
    });
  };

  handleChange = (e, index) => {
    const { organizations } = this.state;
    const { name, value } = e.target;
    const newRows = organizations.map((row, i) => {
      if (i === index) {
        return { ...row, [name]: value, isChange: true };
      }
      return row;
    });
    this.setState({ organizations: newRows, isChanged: true });
  };

  handleFocus = (index) => {
    this.setState({ rowIndex: index });
  };

  handleUnFocus = () => {
    this.setState({ rowIndex: null });
  };

  goToPage = (data) => {
    this.props.wizard.setActiveStep(data.wizardStep);

    const { navigations } = this.props.wizard.toJS();
    const nav = navigations.filter((nav) => nav.wizardStep < data.wizardStep);
    this.props.wizard.setNavigation(nav);
  };

  render() {
    const { classes, t } = this.props;
    const { rowIndex, organizations } = this.state;
    const { navigations } = this.props.wizard.toJS();
    return (
      <div>
        <Grid container>
          <Grid container item sm={12}>
            {(navigations || []).map((nav, i) => (
              <div id={nav.wizardPage} className={classes.nav} key={i} onClick={() => this.goToPage(nav)}>
                {' '}
                {t(`${nav.wizardName}`)}
                {' > '}
              </div>
            ))}
            <div className={classes.activeNav}>{t('wizard_step_unit')}</div>
          </Grid>
          <Grid container item xs={12} sm={12} md={8}>
            <div className={classes.textHeader}>{t('wizard_step_unit_for')}</div>
            <div className={classes.textHeaderPrimary}>{navigations[1].wizardName}</div>
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.wrapButton}>
            <Button
              id='create'
              variant='contained'
              style={{
                backgroundColor: '#009D9A',
                color: '#fff',
                borderRadius: 8,
              }}
              onClick={() => this.handleClickCreate()}
            >
              <div style={{ marginRight: 5 }}>
                <svg width='24' height='24' viewBox='0 0 24 24' style={{ fill: '#fff' }}>
                  <use xlinkHref={`/images/menus-v1.svg#add-circle`} />
                </svg>
              </div>
              {t('wizard_organization_create')}
            </Button>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
          <Paper className={classes.paperTable}>
            <div style={{ overflow: 'auto', maxHeight: '543px' }}>
              <Table>
                <TableHead>
                  <TableRow style={{ border: 'none' }}>
                    <CustomTableCell style={{ borderTopLeftRadius: '8px' }}>
                      {t('wizard_organization_name')}
                    </CustomTableCell>
                    <CustomTableCell>{t('description')}</CustomTableCell>
                    <CustomTableCell style={{ borderTopRightRadius: '8px' }}>{t('action')}</CustomTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {organizations.length === 0 && (
                    <TableRow style={{ borderTop: '1px solid #B8CFC3' }}>
                      <TableCell style={{ padding: '20px' }} colSpan={12}>
                        <Grid item xs={12} sm={12} style={{ textAlign: 'center', margin: 10 }}>
                          <div
                            style={{
                              justifyContent: 'center',
                              display: 'flex',
                            }}
                          >
                            <svg width='56' height='56' viewBox='0 0 56 56'>
                              <use xlinkHref={`/images/menus-v1.svg#folder`} />
                            </svg>
                          </div>
                          <div style={{ margin: 5 }}>
                            <Typography className={classes.textTitle}>{t('wizard_no_organization')}</Typography>
                          </div>
                          <div style={{ margin: 10 }}>
                            <Typography className={classes.textSubTitle}>
                              {t('wizard_no_organization_detail')}
                            </Typography>
                            <Typography className={classes.textSubTitle}>
                              {t('wizard_pls_create_organization')}
                            </Typography>
                          </div>
                          <Button
                            id='create-organization'
                            variant='contained'
                            style={{
                              backgroundColor: '#009D9A',
                              color: '#fff',
                              borderRadius: 8,
                            }}
                            onClick={() => this.handleClickCreate()}
                          >
                            <div style={{ marginRight: 5 }}>
                              <svg width='24' height='24' viewBox='0 0 24 24' style={{ fill: '#fff' }}>
                                <use xlinkHref={`/images/menus-v1.svg#add-circle`} />
                              </svg>
                            </div>
                            {t('wizard_organization_create')}
                          </Button>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  )}
                  {organizations.length > 0 &&
                    organizations.map((data, i) => (
                      <TableRow key={i}>
                        <CustomTableCell component='th' scope='row'>
                          <TextField
                            id='name'
                            name='name'
                            variant='outlined'
                            margin='dense'
                            fullWidth
                            value={data.name}
                            onChange={(e) => this.handleChange(e, i)}
                            onFocus={() => this.handleFocus(i)}
                            onBlur={() => this.handleUnFocus()}
                            className={classes.textField}
                            InputProps={{
                              className:
                                rowIndex === i
                                  ? classes.input
                                  : data.name.length > 0
                                    ? classes.inputNoBorder
                                    : classes.input,
                              readOnly: rowIndex !== i,
                            }}
                          />
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row'>
                          <TextField
                            id='description'
                            name='description'
                            variant='outlined'
                            margin='dense'
                            fullWidth
                            value={data.description}
                            onChange={(e) => this.handleChange(e, i)}
                            onFocus={() => this.handleFocus(i)}
                            onBlur={() => this.handleUnFocus()}
                            className={classes.textField}
                            InputProps={{
                              className:
                                rowIndex === i
                                  ? classes.input
                                  : data.name.length > 0
                                    ? classes.inputNoBorder
                                    : classes.input,
                              readOnly: rowIndex !== i,
                            }}
                          />
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row'>
                          <Grid container alignItems='center'>
                            <IconButton
                              id={`delete-${data.id}`}
                              className={classes.btnIcon}
                              onClick={() => this.handleOpendWarningForm(i, data.name)}
                            >
                              <svg width='24' height='24' viewBox='0 0 16 16'>
                                <use xlinkHref={`/images/menus-v1.svg#trash`} />
                              </svg>
                            </IconButton>
                          </Grid>
                        </CustomTableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>

        <Grid container style={{ marginTop: 20, justifyContent: 'space-between' }}>
          <div style={{ display: 'flex' }}>
            <Button
              id='back'
              variant='outlined'
              color='primary'
              style={{ marginRight: 10 }}
              onClick={this.handleBack}
              className={classes.btnPrimary}
            >
              {t('back')}
            </Button>
          </div>
          <div style={{ display: 'flex' }}>
            {this.state.isChanged && (
              <Button
                id='reset'
                variant='outlined'
                color='primary'
                style={{ marginRight: 10 }}
                onClick={this.handleResetData}
                className={classes.btnPrimary}
              >
                {t('wizard_reset_data')}
              </Button>
            )}
            {this.state.isChanged && (
              <Button
                id='save'
                variant='outlined'
                color='primary'
                style={{ marginRight: 10 }}
                className={classes.btnPrimary}
                onClick={this.handleSave}
              >
                {t('save')}
              </Button>
            )}
            <Button
              id='continue'
              variant='contained'
              color='primary'
              onClick={this.handleNext}
              className={classes.btnPrimary}
              disabled={organizations.length === 0}
            >
              {t('wizard_continue')}
            </Button>
          </div>
        </Grid>

        <WarningForm
          open={this.state.dialogWarningForm.open}
          handleSubmitForm={this.handleDelete}
          handleCloseForm={this.handleCloseWarningForm}
          cancelButtonText={t('no')}
          confirmButtonText={t('confirm')}
          headerTitle={t('wizard_organization_delete')}
          subTitle={t('wizard_organization_delete_subtitle').replace('x', this.state.dialogWarningForm.name)}
        />
      </div>
    );
  }
}

const CustomTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: 'rgba(230, 244, 243, 0.5)',
    color: theme.palette.text.header,
    border: 'none',
  },
  body: {
    fontSize: 16,
    borderTop: '1px solid #B8CFC3',
    borderBottom: 'none',
  },
}))(TableCell);

const styles = (theme) => ({
  textHeader: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  textHeaderPrimary: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: 30,
    marginLeft: 5,
  },
  textTitle: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 20,
  },
  textSubTitle: {
    color: '#858585', //theme.palette.text.hint,
    fontWeight: 500,
    fontSize: 16,
  },
  wrapButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'right',
    },
  },
  btnPrimary: {
    width: 180,
    borderRadius: '4px',
  },
  paperTable: {
    boxShadow: 'none',
    border: '1px solid #B8CFC3',
    borderRadius: '8px',
  },
  textField: {
    fontWeight: 400,
    fontSize: 16,
  },
  input: {
    color: theme.palette.text.primary,
    height: 40,
  },
  inputNoBorder: {
    '& fieldset': {
      border: 'none !important',
    },
    color: theme.palette.text.primary,
    height: 40,
  },
  btnIcon: {
    marginRight: 10,
    borderRadius: 4,
    padding: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    fill: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.bg,
    '&:hover': {
      fill: theme.palette.primary.bg,
      backgroundColor: theme.palette.primary.main,
    },
    '&:disabled': {
      fill: theme.palette.disable.main,
      backgroundColor: theme.palette.disable.light,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 5,
    },
  },
  nav: {
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    marginRight: 5,
  },
  activeNav: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
});

export const page = inject('wizard', 'tenant', 'group', 'locations')(observer(SubOrganization));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
